import { useMemo } from 'react';
import { List } from '@components/content/List';
import { NoData } from '@components/content/NoData';
import { setZeroPad } from '@utils/index';
import { useOption } from '@hooks/useOption';
import type { IDataByDateMap, ISetDataItem, IDataMap, IDateObj, IL10n } from '@type/index';

interface IContentProps {
    selectedDate: IDateObj;
    isScheduleSuccess: boolean;
    dataMap: IDataMap;
    dataByDateMap: IDataByDateMap;
    l10n: IL10n;
}

// 콘텐츠 데이터 추출
const getContentData = (selectedDate: IDateObj, dataMap: IDataMap, dataByDateMap: IDataByDateMap) => {
    if(!dataMap || !selectedDate || !dataByDateMap) {
        return null;
    }

    const { year, month, date } = selectedDate || {};
    const dataByDate = year && month && date && dataByDateMap[year] && dataByDateMap[year][month - 1][date - 1];
    let contentData: ISetDataItem[][] = [];        

    if(Array.isArray(dataByDate) && dataByDate?.length > 0) {
        let prevParentId: string | null = null;
        contentData = dataByDate?.reduce((acc, curVal) => {
            const curParentId = curVal?.split('-')[0];
            if(!prevParentId || (prevParentId !== curParentId)) {
                acc.push([]);
            }

            acc[acc.length - 1].push(dataMap[curVal] as ISetDataItem);
            prevParentId = curParentId;

            return acc;
        }, contentData);
    }

    return contentData;
};

export const Content = (props: IContentProps) => {
    const { selectedDate, isScheduleSuccess, dataMap, dataByDateMap, l10n } = props || {};
    const { serviceAlias } = useOption() || {};
    const contentData = useMemo(() => getContentData(selectedDate, dataMap, dataByDateMap), [selectedDate, dataMap, dataByDateMap]);

    return <section className="schedule-content-wrap">
        <div className="schedule-content">
            <h1 className="schedule-content-title">
                <strong>{setZeroPad(selectedDate?.month)}.{setZeroPad(selectedDate?.date)}.</strong> {l10n?.content[`${serviceAlias}Title`] || ''}
            </h1>
            { isScheduleSuccess && Array.isArray(contentData) && contentData?.length > 0 ? <List contentData={contentData} /> : <NoData l10n={l10n} /> }
        </div>
        
    </section>;
};